export default {
  api: {
    url: {
      axios: 'https://api.cslobby.gg/',
      sockets: 'https://api.cslobby.gg/',
    },
    version: {
      axios: 'v1',
    },
    key: {
      axios: 'YZmTozhjN547jccoo3FBMx8F3dr9ywEu3sB7fgySoLA9BFmxVKVmMfk7GA5BXs2W',
      bugsnag: '670a4193e00b289f0cb9e567ffbf3d4d',
    },
  },
  // api-core (v2) gather domain. Origin only (client appends /v2/, WS URL derived).
  // The legacy `api` block above is left untouched — user auth stays on it.
  apicore: {
    url: process.env.VUE_APP_APICORE_URL || 'https://api.cslobby.gg',
    guildId: process.env.VUE_APP_GUILD_ID || '',
  },
  communication: [
    {
      name: 'Discord',
      alias: 'discord',
      url: 'https://discord.gg/JFqKrd7xDD',
    },
  ],
};
